module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAA2klEQVRIx2O4Iy5DDKqqmuS+7jxBBFRGpIEMg8jip0ESdyTobvE9BZnPm4WeeEsOgI9fZojfVZamt8VPfSW/XxR80yR6R4qOFgPD+W2X6O9X/EC7H9lL0tHHkjJv2kTfTxV50yL62EWSrkH90FIS6OlnkRL0i2NgCH9YJPIsXPLbcaE3DWLP08SBIs8TxOlkMRy96xelq8UPzKVe14s98ZcEWklXi7/uE/qyV+jbEcGXxWJ0tfjTGmFgyfX7JT+9LX5gKvWqQuxZhAS9g3rAEtcAZKcR3BCgj8UA44w4cV/bPzsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mn.png
// module id = 881
// module chunks = 0